// import React, { useState } from 'react';
// import classes from "./ConfirmationPage2.module.css";

// const ConfirmationPage2 = () => {
//   const [status, setStatus] = useState("idle"); // idle | sending | sent

//   const handleProceed = () => {
//     if (status !== "idle") return;
//     setStatus("sending");
//     setTimeout(() => setStatus("sent"), 1400);
//   };

//   return (
//     <div className={classes.wrapper}>
//       <div className={classes.phone}>
//         <div className={classes.notch} />

//         <div className={classes.statusBar}>
//           <span className={classes.time}>9:41</span>
//           <div className={classes.statusIcons}>
//             <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
//               <rect x="0" y="7" width="3" height="5" rx="0.5" fill="currentColor" />
//               <rect x="5" y="5" width="3" height="7" rx="0.5" fill="currentColor" />
//               <rect x="10" y="2" width="3" height="10" rx="0.5" fill="currentColor" />
//               <rect x="15" y="0" width="3" height="12" rx="0.5" fill="currentColor" />
//             </svg>
//             <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
//               <path d="M8 3C10.5 3 12.7 4 14.3 5.6L13 7C11.7 5.7 9.9 5 8 5C6.1 5 4.3 5.7 3 7L1.7 5.6C3.3 4 5.5 3 8 3Z" fill="currentColor" />
//               <circle cx="8" cy="9.5" r="1.3" fill="currentColor" />
//             </svg>
//             <svg width="24" height="12" viewBox="0 0 24 12" fill="none">
//               <rect x="0.5" y="0.5" width="20" height="11" rx="2.5" stroke="currentColor" />
//               <rect x="2" y="2" width="16" height="8" rx="1.2" fill="currentColor" />
//               <rect x="21" y="4" width="2" height="4" rx="1" fill="currentColor" />
//             </svg>
//           </div>
//         </div>

//         <div className={classes.appHeader}>
//           <svg className={classes.backIcon} width="12" height="20" viewBox="0 0 12 20" fill="none">
//             <path d="M10 2L2 10L10 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//           </svg>
//           <div className={classes.contactBlock}>
//             <div className={classes.avatar}>1525</div>
//             <span className={classes.contactLabel}>Text Message</span>
//           </div>
//           <div className={classes.headerSpacer} />
//         </div>

//         <div className={classes.thread}>
//           <span className={classes.dateDivider}>Today 9:41 AM</span>

//           <div className={classes.incomingRow}>
//             <div className={classes.bubbleIncoming}>
//               You are being invited to subscribe to a service. Daily and Weekly plans available. Reply <b>SUB</b> to confirm your subscription. Reply <b>STOP</b> to opt out anytime.
//             </div>
//           </div>
//           <span className={classes.bubbleTime}>Delivered · 9:41 AM</span>

//           {status === "sent" && (
//             <div className={classes.outgoingRow}>
//               <div className={classes.bubbleOutgoing}>SUB</div>
//             </div>
//           )}
//           {status === "sent" && (
//             <span className={classes.bubbleTimeRight}>Delivered</span>
//           )}
//         </div>

//         <div className={classes.composeBar}>
//           <div className={classes.composeField}>
//             <span className={status === "sent" ? classes.composeTextSent : classes.composeText}>
//               {status === "sent" ? "Message sent" : "SUB"}
//             </span>
//           </div>
//           <button
//             className={`${classes.proceedButton} ${status !== "idle" ? classes.proceedButtonBusy : ""}`}
//             onClick={handleProceed}
//             disabled={status !== "idle"}
//           >
//             {status === "idle" && "Proceed"}
//             {status === "sending" && "Sending"}
//             {status === "sent" && (
//               <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
//                 <path d="M1 6L5.5 10.5L15 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//               </svg>
//             )}
//           </button>
//         </div>

//         {status === "sent" && (
//           <div className={classes.confirmToast}>
//             Subscription request sent to 1525
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ConfirmationPage2;


import React, { useState } from 'react';
import classes from "./ConfirmationPage2.module.css";

const ConfirmationPage2 = () => {
  const [status, setStatus] = useState("idle"); // idle | sending | sent

  const handleProceed = () => {
    if (status !== "idle") return;
    setStatus("sending");
    setTimeout(() => setStatus("sent"), 1400);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.phone}>
        <div className={classes.notch} />

        <div className={classes.statusBar}>
          <span className={classes.time}>9:41</span>
          <div className={classes.statusIcons}>
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
              <rect x="0" y="7" width="3" height="5" rx="0.5" fill="currentColor" />
              <rect x="5" y="5" width="3" height="7" rx="0.5" fill="currentColor" />
              <rect x="10" y="2" width="3" height="10" rx="0.5" fill="currentColor" />
              <rect x="15" y="0" width="3" height="12" rx="0.5" fill="currentColor" />
            </svg>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path d="M8 3C10.5 3 12.7 4 14.3 5.6L13 7C11.7 5.7 9.9 5 8 5C6.1 5 4.3 5.7 3 7L1.7 5.6C3.3 4 5.5 3 8 3Z" fill="currentColor" />
              <circle cx="8" cy="9.5" r="1.3" fill="currentColor" />
            </svg>
            <svg width="24" height="12" viewBox="0 0 24 12" fill="none">
              <rect x="0.5" y="0.5" width="20" height="11" rx="2.5" stroke="currentColor" />
              <rect x="2" y="2" width="16" height="8" rx="1.2" fill="currentColor" />
              <rect x="21" y="4" width="2" height="4" rx="1" fill="currentColor" />
            </svg>
          </div>
        </div>

        <div className={classes.appHeader}>
          <svg className={classes.backIcon} width="12" height="20" viewBox="0 0 12 20" fill="none">
            <path d="M10 2L2 10L10 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className={classes.contactBlock}>
            <div className={classes.avatar}>1525</div>
            <span className={classes.contactLabel}>Text Message</span>
          </div>
          <div className={classes.headerSpacer} />
        </div>

        <div className={classes.thread}>
          <span className={classes.dateDivider}>Today 9:41 AM</span>

          <div className={classes.incomingRow}>
            <div className={classes.bubbleIncoming}>
              You are being invited to subscribe to a service. Daily and Weekly plans available. Reply <b>SUB</b> to confirm your subscription. Reply <b>STOP</b> to opt out anytime.
            </div>
          </div>
          <span className={classes.bubbleTime}>Delivered · 9:41 AM</span>

          {status === "sent" && (
            <div className={classes.outgoingRow}>
              <div className={classes.bubbleOutgoing}>SUB</div>
            </div>
          )}
          {status === "sent" && (
            <span className={classes.bubbleTimeRight}>Delivered</span>
          )}
        </div>

        {status === "idle" && (
          <div className={classes.hintRow}>
            <span className={classes.hintText}>Tap Proceed to send SUB</span>
            <svg className={classes.hintArrow} width="20" height="26" viewBox="0 0 20 26" fill="none">
              <path d="M10 1V19" stroke="#00b87c" strokeWidth="2.5" strokeLinecap="round" />
              <path d="M2 13L10 21L18 13" stroke="#00b87c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        )}

        <div className={classes.composeBar}>
          <div className={classes.composeField}>
            <span className={status === "sent" ? classes.composeTextSent : classes.composeText}>
              {status === "sent" ? "Message sent" : "SUB"}
            </span>
          </div>
          <button
            className={`${classes.proceedButton} ${status !== "idle" ? classes.proceedButtonBusy : ""}`}
            onClick={handleProceed}
            disabled={status !== "idle"}
          >
            {status === "idle" && "Proceed"}
            {status === "sending" && "Sending"}
            {status === "sent" && (
              <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
                <path d="M1 6L5.5 10.5L15 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>
        </div>

        {status === "sent" && (
          <div className={classes.confirmToast}>
            Subscription request sent to 1525
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationPage2;